<template>
  <CFooter :fixed="false">
    <!-- <div>
      <a href="https://spliceglobal.com" target="_blank">SpliceGlobal Pvt Ltd.</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} creativeLabs.</span>
    </div> -->
    <div class="ml-auto">
      <!-- <span class="mr-1">Powered by</span> -->
      <a href="https://apachedigital.io" target="_blank">Apache Digital &copy; 2021</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
